import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SuccessMarquee from "@/components/SuccessMarquee";
import About from "@/components/About";
import Steps from "@/components/Steps";
import Courses from "@/components/Courses";
import ExamPapers from "@/components/ExamPapers";
import QuoteBanner from "@/components/QuoteBanner";
import Achievers from "@/components/Achievers";
import News from "@/components/News";
import VaseisCard from "@/components/VaseisCard";
import ExamSchedule from "@/components/ExamSchedule";
import DiagnosticCard from "@/components/DiagnosticCard";
import MembersCard from "@/components/MembersCard";
import EduReforms from "@/components/EduReforms";
import CareerGuidance from "@/components/CareerGuidance";
import EduNews from "@/components/EduNews";
import FacebookFeed from "@/components/FacebookFeed";
import Enrollment from "@/components/Enrollment";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import Calendar from "@/pages/Calendar";
import Vaseis from "@/pages/Vaseis";
import Quiz from "@/pages/Quiz";
import Members from "@/pages/Members";
import { Toaster } from "@/components/ui/sonner";
import { useUppercaseNoTones } from "@/lib/noTones";
import { usePageView } from "@/lib/track";

function Home() {
  return (
    <div className="App font-body bg-background text-foreground" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <SuccessMarquee />
        <About />
        <Steps />
        <Courses />
        <ExamPapers />
        <QuoteBanner />
        <Achievers />
        <News />
        <VaseisCard />
        <ExamSchedule />
        <DiagnosticCard />
        <MembersCard />
        <EduReforms />
        <CareerGuidance />
        <EduNews />
        <FacebookFeed />
        <Enrollment />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  useUppercaseNoTones();
  usePageView();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/vaseis" element={<Vaseis />} />
        <Route path="/test" element={<Quiz />} />
        <Route path="/members" element={<Members />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
